import type { CurrentCommunityMember } from '~/interfaces/community';

const hasOnboardName = (member: CurrentCommunityMember | null | undefined): boolean => {
  const firstName = member?.subscription.first_name?.trim();
  const lastName = member?.subscription.last_name?.trim();
  return Boolean(firstName && lastName);
};

export const needsProfileOnboarding = (member: CurrentCommunityMember | null | undefined): boolean => {
  if (!member) return false;
  if (!hasOnboardName(member)) return true;
  return member.onboarding_completed === false;
};

export const needsRequiredProfileSetup = ({
  member,
  accessible,
}: {
  member: CurrentCommunityMember | null | undefined;
  accessible: boolean;
}): boolean => Boolean(accessible && member?.onboarding_completed && member.profile_setup_required);
